import { render, staticRenderFns } from "./BoardStepper.vue?vue&type=template&id=87d2640a&"
import script from "./BoardStepper.vue?vue&type=script&lang=js&"
export * from "./BoardStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports